import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send reset email');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left side - form */}
      <div className="flex-1 flex items-center justify-center bg-[#F6F5FA] px-6 py-12 lg:py-0 lg:w-1/2">
        <div className="w-full max-w-[400px] lg:bg-white lg:rounded-[28px] lg:p-10 lg:shadow-[0_1px_2px_rgba(17,12,34,0.04),0_12px_32px_rgba(17,12,34,0.08)]">
          <div className="text-center mb-6">
            <img src="/cscore-logo.png" alt="CScore" className="h-10 mx-auto" style={{ filter: 'brightness(0) saturate(100%) invert(13%) sepia(90%) saturate(5500%) hue-rotate(270deg) brightness(80%) contrast(110%)' }} />
          </div>

          {sent ? (
            <div className="text-center">
              <h2 className="text-[30px] font-bold tracking-[-0.02em] text-[#111] mb-4">Check Your Email</h2>
              <p className="text-sm text-gray-600 mb-6">
                If an account exists for <strong>{email}</strong>, a password reset link has been sent.
              </p>
              <Link to="/login" className="text-primary font-medium text-sm hover:underline">
                Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-[30px] font-bold tracking-[-0.02em] text-[#111] text-center mb-2">Reset Password</h2>
              <p className="text-sm text-gray-600 text-center mb-8">
                Enter your email and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-[14px] font-semibold text-[#111] mb-1.5">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full h-12 bg-white border border-[#E5E2EE] rounded-[14px] px-4 text-[16px] md:text-[15px] text-[#111] focus:outline-none focus:ring-4 focus:ring-primary-10 focus:border-primary-40 transition"
                  />
                </div>

                {error && (
                  <div className="mb-4 p-3 bg-destructive-10 border border-destructive-30 rounded-lg text-sm text-destructive">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-12 rounded-[14px] bg-primary text-white font-semibold text-[15px] shadow-[0_8px_20px_rgba(108,24,201,0.28)] hover:bg-primary-80 transition-colors disabled:opacity-50"
                >
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>

                <p className="text-sm text-gray-600 mt-4 text-center">
                  Remember your password?{' '}
                  <Link to="/login" className="text-primary font-medium hover:underline">Sign In</Link>
                </p>
              </form>
            </>
          )}
        </div>
      </div>

      {/* Right side - gradient (hidden on mobile) */}
      <div
        className="hidden lg:flex lg:w-1/2 lg:m-4 lg:rounded-[32px] flex-col items-center justify-center px-12"
        style={{ background: 'radial-gradient(120% 90% at 0% 0%, #8B3FE6 0%, #6C18C9 45%, #3E0A78 100%)' }}
      >
        <h2 className="text-white text-4xl font-bold mb-4 text-center">Measure What Matters</h2>
        <p className="text-white/80 text-lg text-center max-w-md leading-relaxed">
          Track clinician performance, improve patient outcomes, and make data-driven decisions for your treatment center.
        </p>
      </div>
    </div>
  );
}
